import { NgModule, CUSTOM_ELEMENTS_SCHEMA, importProvidersFrom, LOCALE_ID } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { AppComponent } from './app.component';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { IMaskModule } from 'angular-imask';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { APP_ROUTING, AppRoutingModule, routes } from './app-routing.module';
import { MaterialModule } from './shared/modules/material.module';
import { PrimeNgModule } from '@shared/modules/primeng.module';
import { ParametriaLayoutComponent } from './layouts/parametria-layout/parametria-layout.component';
import { Router, RouterModule } from '@angular/router';
import { APP_ROUTING_LAYOUT, ParametriaRoutes } from './layouts/parametria-layout/parametria-layout-routing.module';
import { UserComponent } from './pages/user/user.component';
import { UserFormComponent } from './pages/user/user-form/user-form.component';
import { ParametriaLayoutModule } from './layouts/parametria-layout/parametria-layout.module';
import { IndexComponent } from '@pages/index/index.component';
import { AdminLayoutComponent } from './layouts/admin-layout/admin-layout.component';
import { AdminLayoutModule } from './layouts/admin-layout/admin-layout.module';
import { MenuItemComponent } from '@shared/components/menu-item/menu-item.component';
import { ActividadesComponent } from './pages/actividades/actividades.component';
import { ActividadesFormComponent } from './pages/actividades/actividades-form/actividades-form.component';
import { MatMenuModule } from '@angular/material/menu';
import { MatSidenavModule } from '@angular/material/sidenav';
import { LayoutsComponent } from './theme/layouts/layouts.component';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatTreeModule } from '@angular/material/tree';
import { HeaderComponent } from './theme/header/header.component';
import { AsideComponent } from './theme/aside/aside.component';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { BredcumbsComponent } from './theme/bredcumbs/bredcumbs.component';
import { LoadingComponent } from './theme/loading/loading.component';
import { MatPaginatorModule } from '@angular/material/paginator';
import { HelpersService } from '@shared/helpers/helpers.service';
import { DatePipe, HashLocationStrategy, LocationStrategy, registerLocaleData } from '@angular/common';
import { ForgotPasswordComponent } from '@pages/authentication/components/forgot-password/forgot-password.component';
import { AuthHttpInterceptorService } from '@pages/authentication/services/auth-http-interceptor.service';
import { APP_ADMIN_ROUTES, AdminRoutes } from './layouts/admin-layout/admin-layout-routing.module';
import { UserService } from '@pages/user/services/user.service';
import { AuthService } from './auth.service';
import { TieredMenuModule } from 'primeng/tieredmenu';
import { HomeComponent } from '@pages/home/home.component';
import { MatSortModule } from '@angular/material/sort';
import localeEs from '@angular/common/locales/es';
import { DefGeneralComponent } from '@p-p-portafolio/promociones/definiciones/definiciones-form/def-general/def-general.component';
import { DefMoratoriosComponent } from '@p-p-portafolio/promociones/definiciones/definiciones-form/def-moratorios/def-moratorios.component';
import { NewAuthHttpInterceptorService } from '@pages/authentication/services/new-auth-http-interceptor.service';
import { ReportingFilterComponent } from '@shared/components/reports/reporting-filter/reporting-filter.component';
import { LibranzaActualComponent } from '@pages/libranzas/libranza-actual/libranza-actual.component';
import { ReportesLibranzasComponent } from '@pages/libranzas/reportes-libranzas/reportes-libranzas.component';
import { CentroMensajesComponent } from '@pages/centro-mensajes/centro-mensajes.component';
import { SelectButtonModule } from 'primeng/selectbutton';
import { DocumentatorComponent } from '@shared/components/documentator/documentator.component';
import { PermissionsService } from '@shared/utils/permissions/permissions.service';
import { APP_INITIALIZER } from '@angular/core';
import { AsignacionMasivaComponent } from '@shared/components/asignacion-masiva/asignacion-masiva.component';
import { CryptDataService } from '@shared/utils/crypt-data.service';
import { AppSharedModule } from '@shared/modules/AppSharedModule.module';
import { UserNivelesComponent } from '@pages/user/user-niveles/user-niveles.component';
import { CoreModule } from './core/core.module';
registerLocaleData(localeEs, 'es');export function initializePermissions(permissionService: PermissionsService, cryptData: CryptDataService, router: Router) {
  const rol = sessionStorage.getItem('p9sh2');
  
  if (!rol || rol === '0') {
    // Si no hay rol o es 0, verificar si hay datos de usuario encriptados
    const userData = sessionStorage.getItem('user');
    
    if (userData) {
      // Si hay datos de usuario, intentar recuperar el rol de los datos encriptados
      try {
        const decryptedUser = JSON.parse(userData.replace(/['"]+/g, ''));
        
        if (decryptedUser && decryptedUser.rolId) {
          sessionStorage.setItem('p9sh2', decryptedUser.rolId.toString());
        } else {
          sessionStorage.setItem('p9sh2', '0');
        }
      } catch (error) {
        console.error('Error al recuperar rol de datos encriptados:', error);
        sessionStorage.setItem('p9sh2', '0');
      }
    } else {
      sessionStorage.setItem('p9sh2', '0');
    }
  }
  
  // Cargar permisos si hay un rol válido
  const rolFinal = sessionStorage.getItem('p9sh2');
  if (rolFinal && rolFinal !== '0') {
    return () => permissionService.loadPermissions(parseInt(rolFinal)).catch((error) => {
      console.error('Error al cargar permisos:', error);
    });
  }
  
  return () => Promise.resolve();
}

@NgModule({
  declarations: [
    AppComponent,
    DefGeneralComponent,
    DefMoratoriosComponent,
    ParametriaLayoutComponent,
    UserComponent,
    UserFormComponent,
    IndexComponent,
    AdminLayoutComponent,
    MenuItemComponent,
    HomeComponent,
    ActividadesComponent,
    ActividadesFormComponent,
    LayoutsComponent,
    HeaderComponent,
    AsideComponent,
    BredcumbsComponent,
    LoadingComponent,
    ReportingFilterComponent,
    LibranzaActualComponent,
    ReportesLibranzasComponent,
    CentroMensajesComponent,
    DocumentatorComponent,
    UserNivelesComponent
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  bootstrap: [AppComponent],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    CoreModule,
    AppRoutingModule,
    MaterialModule,
    PrimeNgModule,
    ParametriaLayoutModule,
    AdminLayoutModule,
    MatMenuModule,
    TieredMenuModule,
    APP_ROUTING,
    APP_ROUTING_LAYOUT,
    APP_ADMIN_ROUTES,
    MatSidenavModule,
    MatExpansionModule,
    MatTreeModule,
    RouterModule.forRoot(routes),
    RouterModule.forRoot(ParametriaRoutes),
    RouterModule.forRoot(AdminRoutes),
    FormsModule,
    ReactiveFormsModule,
    IMaskModule,
    MatPaginatorModule,
    MatSortModule,
    MatSnackBarModule,
    SelectButtonModule,
    AppSharedModule
  ],
  providers: [
    {
      provide: APP_INITIALIZER,
      useFactory: initializePermissions,
      deps: [PermissionsService, CryptDataService],
      multi: true
    },
    { provide: LOCALE_ID, useValue: 'es' },
    LoadingComponent,
    DatePipe,
    { provide: LocationStrategy, useClass: HashLocationStrategy }
  ]
})
export class AppModule {}
